export default {
  setBrokersSummaryPagination({ commit }, value) {
    commit('setBrokersSummaryPagination', value);
  }
}